import BasePlugin from 'app/plugins/basePlugin';

class DefaultPlugin extends BasePlugin {
  static displayName = 'DefaultPlugin';
}

export {DefaultPlugin};
